import { Component, Optional, Inject, Injector, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, NG_ASYNC_VALIDATORS } from '@angular/forms';

import { InputBase } from '../../../base/input-base';


@Component({
    selector: 'aa-input-date',
    templateUrl: './input-date.component.html',
    styleUrls: [
        '../input.component.scss'
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputDateComponent,
            multi: true,
        }],
    standalone: false
})
export class InputDateComponent extends InputBase<string> implements OnInit
{
    private static identifier = 0;

    constructor(
        @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
        injector: Injector
    )
    {
        super(injector);
        this.fieldId = `input-date-${InputDateComponent.identifier++}-id`;
    }

    ngOnInit ()
    {
    }
}
